// @ts-nocheck
import { useEffect, useState } from 'react';
import { ownerApi } from './ownerApi';
import PageHeader from './ui/PageHeader';
import Card from './ui/Card';
import Button from './ui/Button';
import Alert from './ui/Alert';

export default function OwnerGuestChat() {
  const [daily, setDaily] = useState(10);
  const [length, setLength] = useState(2000);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  async function load() {
    setLoading(true);
    setError('');
    try {
      const data = await ownerApi.guestChatLimits();
      setDaily(data.settings.daily_question_count);
      setLength(data.settings.max_question_length);
    } catch (err) {
      setError(err?.message || 'Could not load guest chat limits.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function save(event) {
    event.preventDefault();
    setSaving(true);
    setSaved('');
    setError('');
    try {
      const data = await ownerApi.saveGuestChatLimits({
        daily_question_count: Number(daily),
        max_question_length: Number(length),
      });
      setDaily(data.settings.daily_question_count);
      setLength(data.settings.max_question_length);
      setSaved('Saved. Guest chat uses these limits now.');
    } catch (err) {
      setError(err?.message || 'Could not save guest chat limits.');
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <p className="p-6">Loading guest chat limits…</p>;

  return (
    <div className="space-y-4">
      <PageHeader title="Guest chat limits" subtitle="Daily questions and max length apply per device and IP." />
      {error ? <Alert title={error} /> : null}
      {saved ? <p className="text-sm text-teal-800">{saved}</p> : null}
      <Card>
        <form onSubmit={save} className="grid max-w-xl gap-3">
          <label className="text-sm">
            Daily question count
            <input
              aria-label="Daily question count"
              className="mt-1 h-9 w-full rounded-lg border border-[#7C8798] px-3"
              type="number"
              min="1"
              max="100"
              value={daily}
              onChange={(event) => setDaily(event.target.value)}
            />
          </label>
          <label className="text-sm">
            Max question length (characters)
            <input
              aria-label="Max question length"
              className="mt-1 h-9 w-full rounded-lg border border-[#7C8798] px-3"
              type="number"
              min="20"
              max="16000"
              value={length}
              onChange={(event) => setLength(event.target.value)}
            />
          </label>
          <p className="text-[13px] text-slate-600">
            Clearing the guest session id does not reset the cap. The count resets at the next UTC day.
          </p>
          <Button type="submit" loading={saving}>{saving ? 'Saving…' : 'Save limits'}</Button>
        </form>
      </Card>
    </div>
  );
}
